let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eRoc9")).then(() => parcelRequire('4CxKE'));